// Generated by purs version 0.15.0
import * as Data_Eq from "../Data.Eq/index.js";
import * as Data_Eq_Generic from "../Data.Eq.Generic/index.js";
import * as Data_Generic_Rep from "../Data.Generic.Rep/index.js";
import * as Data_Maybe from "../Data.Maybe/index.js";
import * as Data_Money_Rounded from "../Data.Money.Rounded/index.js";
import * as Data_MultiSet from "../Data.MultiSet/index.js";
import * as Data_Ord from "../Data.Ord/index.js";
import * as Data_Ord_Generic from "../Data.Ord.Generic/index.js";
import * as Data_Set from "../Data.Set/index.js";
import * as Data_Show from "../Data.Show/index.js";
import * as Data_Show_Generic from "../Data.Show.Generic/index.js";
import * as Foreign_Generic_Class from "../Foreign.Generic.Class/index.js";
import * as Restaumatic_Menu_Types_Id from "../Restaumatic.Menu.Types.Id/index.js";
import * as Restaumatic_Menu_V2_Types_CartToOrder from "../Restaumatic.Menu.V2.Types.CartToOrder/index.js";
import * as Restaumatic_Menu_V2_Types_Taxes from "../Restaumatic.Menu.V2.Types.Taxes/index.js";
import * as Unscramble from "../Unscramble/index.js";
var SideDishKey = function (x) {
    return x;
};
var StandardPizza = /* #__PURE__ */ (function () {
    function StandardPizza(value0) {
        this.value0 = value0;
    };
    StandardPizza.create = function (value0) {
        return new StandardPizza(value0);
    };
    return StandardPizza;
})();
var CustomPizza = /* #__PURE__ */ (function () {
    function CustomPizza(value0) {
        this.value0 = value0;
    };
    CustomPizza.create = function (value0) {
        return new CustomPizza(value0);
    };
    return CustomPizza;
})();
var Pizza = /* #__PURE__ */ (function () {
    function Pizza(value0) {
        this.value0 = value0;
    };
    Pizza.create = function (value0) {
        return new Pizza(value0);
    };
    return Pizza;
})();
var Dish = /* #__PURE__ */ (function () {
    function Dish(value0) {
        this.value0 = value0;
    };
    Dish.create = function (value0) {
        return new Dish(value0);
    };
    return Dish;
})();
var Drink = /* #__PURE__ */ (function () {
    function Drink(value0) {
        this.value0 = value0;
    };
    Drink.create = function (value0) {
        return new Drink(value0);
    };
    return Drink;
})();
var SplitPizza = /* #__PURE__ */ (function () {
    function SplitPizza(value0) {
        this.value0 = value0;
    };
    SplitPizza.create = function (value0) {
        return new SplitPizza(value0);
    };
    return SplitPizza;
})();
var CustomProduct = /* #__PURE__ */ (function () {
    function CustomProduct(value0) {
        this.value0 = value0;
    };
    CustomProduct.create = function (value0) {
        return new CustomProduct(value0);
    };
    return CustomProduct;
})();
var MenuProduct = /* #__PURE__ */ (function () {
    function MenuProduct(value0) {
        this.value0 = value0;
    };
    MenuProduct.create = function (value0) {
        return new MenuProduct(value0);
    };
    return MenuProduct;
})();
var MenuCombo = /* #__PURE__ */ (function () {
    function MenuCombo(value0) {
        this.value0 = value0;
    };
    MenuCombo.create = function (value0) {
        return new MenuCombo(value0);
    };
    return MenuCombo;
})();
var udecodeForeignSideDishKey = /* #__PURE__ */ Unscramble.decodeRecord1()(/* #__PURE__ */ Unscramble.decodeRecordCons({
    reflectSymbol: function () {
        return "dishId";
    }
})(Restaumatic_Menu_Types_Id.udecodeDishId)(/* #__PURE__ */ Unscramble.decodeRecordCons({
    reflectSymbol: function () {
        return "sideId";
    }
})(Restaumatic_Menu_Types_Id.udecodeForeignSideId)(Unscramble.decodeRecordNil)));
var toSplitPizzaKey = function (v) {
    return {
        parts: [ v.def ],
        size: v.size,
        panType: v.panType
    };
};
var productKeyDishId = function (v) {
    if (v instanceof Dish) {
        return new Data_Maybe.Just(v.value0.id);
    };
    return Data_Maybe.Nothing.value;
};
var pizzaId = function (v) {
    if (v instanceof StandardPizza) {
        return v.value0;
    };
    if (v instanceof CustomPizza) {
        return v.value0.basePizzaId;
    };
    throw new Error("Failed pattern match at Restaumatic.Cart.ProductKey (line 106, column 3 - line 108, column 47): " + [ v.constructor.name ]);
};
var isSplitPizza = function (v) {
    if (v instanceof SplitPizza) {
        return true;
    };
    return false;
};
var isCustomPizza = function (v) {
    if (v instanceof Pizza && v.value0.def instanceof CustomPizza) {
        return true;
    };
    return false;
};
var genericSideDishKey = {
    to: function (x) {
        return x;
    },
    from: function (x) {
        return x;
    }
};
var showSideDishKey = {
    show: /* #__PURE__ */ Data_Show_Generic.genericShow(genericSideDishKey)(/* #__PURE__ */ Data_Show_Generic.genericShowConstructor(/* #__PURE__ */ Data_Show_Generic.genericShowArgsArgument(/* #__PURE__ */ Data_Show.showRecord()()(/* #__PURE__ */ Data_Show.showRecordFieldsCons({
        reflectSymbol: function () {
            return "dishId";
        }
    })(/* #__PURE__ */ Data_Show.showRecordFieldsCons({
        reflectSymbol: function () {
            return "sideId";
        }
    })(Data_Show.showRecordFieldsNil)(Restaumatic_Menu_Types_Id.showSideId))(Restaumatic_Menu_Types_Id.showDishId))))({
        reflectSymbol: function () {
            return "SideDishKey";
        }
    }))
};
var genericProductKey = {
    to: function (x) {
        if (x instanceof Data_Generic_Rep.Inl) {
            return new Pizza(x.value0);
        };
        if (x instanceof Data_Generic_Rep.Inr && x.value0 instanceof Data_Generic_Rep.Inl) {
            return new Dish(x.value0.value0);
        };
        if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0 instanceof Data_Generic_Rep.Inl)) {
            return new Drink(x.value0.value0.value0);
        };
        if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0.value0 instanceof Data_Generic_Rep.Inl))) {
            return new SplitPizza(x.value0.value0.value0.value0);
        };
        if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inl)))) {
            return new CustomProduct(x.value0.value0.value0.value0.value0);
        };
        if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inl))))) {
            return new MenuProduct(x.value0.value0.value0.value0.value0.value0);
        };
        if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr))))) {
            return new MenuCombo(x.value0.value0.value0.value0.value0.value0);
        };
        throw new Error("Failed pattern match at Restaumatic.Cart.ProductKey (line 74, column 1 - line 74, column 58): " + [ x.constructor.name ]);
    },
    from: function (x) {
        if (x instanceof Pizza) {
            return new Data_Generic_Rep.Inl(x.value0);
        };
        if (x instanceof Dish) {
            return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(x.value0));
        };
        if (x instanceof Drink) {
            return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(x.value0)));
        };
        if (x instanceof SplitPizza) {
            return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(x.value0))));
        };
        if (x instanceof CustomProduct) {
            return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(x.value0)))));
        };
        if (x instanceof MenuProduct) {
            return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(x.value0))))));
        };
        if (x instanceof MenuCombo) {
            return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(x.value0))))));
        };
        throw new Error("Failed pattern match at Restaumatic.Cart.ProductKey (line 74, column 1 - line 74, column 58): " + [ x.constructor.name ]);
    }
};
var genericPizzaDef = {
    to: function (x) {
        if (x instanceof Data_Generic_Rep.Inl) {
            return new StandardPizza(x.value0);
        };
        if (x instanceof Data_Generic_Rep.Inr) {
            return new CustomPizza(x.value0);
        };
        throw new Error("Failed pattern match at Restaumatic.Cart.ProductKey (line 93, column 1 - line 93, column 54): " + [ x.constructor.name ]);
    },
    from: function (x) {
        if (x instanceof StandardPizza) {
            return new Data_Generic_Rep.Inl(x.value0);
        };
        if (x instanceof CustomPizza) {
            return new Data_Generic_Rep.Inr(x.value0);
        };
        throw new Error("Failed pattern match at Restaumatic.Cart.ProductKey (line 93, column 1 - line 93, column 54): " + [ x.constructor.name ]);
    }
};
var showPizzaDef = {
    show: /* #__PURE__ */ Data_Show_Generic.genericShow(genericPizzaDef)(/* #__PURE__ */ Data_Show_Generic.genericShowSum(/* #__PURE__ */ Data_Show_Generic.genericShowConstructor(/* #__PURE__ */ Data_Show_Generic.genericShowArgsArgument(Restaumatic_Menu_Types_Id.showPizzaId))({
        reflectSymbol: function () {
            return "StandardPizza";
        }
    }))(/* #__PURE__ */ Data_Show_Generic.genericShowConstructor(/* #__PURE__ */ Data_Show_Generic.genericShowArgsArgument(/* #__PURE__ */ Data_Show.showRecord()()(/* #__PURE__ */ Data_Show.showRecordFieldsCons({
        reflectSymbol: function () {
            return "basePizzaId";
        }
    })(/* #__PURE__ */ Data_Show.showRecordFieldsCons({
        reflectSymbol: function () {
            return "toppings";
        }
    })(Data_Show.showRecordFieldsNil)(/* #__PURE__ */ Data_MultiSet.showMultiSet(Restaumatic_Menu_Types_Id.showToppingId)))(Restaumatic_Menu_Types_Id.showPizzaId))))({
        reflectSymbol: function () {
            return "CustomPizza";
        }
    })))
};
var showProductKey = {
    show: /* #__PURE__ */ Data_Show_Generic.genericShow(genericProductKey)(/* #__PURE__ */ Data_Show_Generic.genericShowSum(/* #__PURE__ */ Data_Show_Generic.genericShowConstructor(/* #__PURE__ */ Data_Show_Generic.genericShowArgsArgument(/* #__PURE__ */ Data_Show.showRecord()()(/* #__PURE__ */ Data_Show.showRecordFieldsCons({
        reflectSymbol: function () {
            return "def";
        }
    })(/* #__PURE__ */ Data_Show.showRecordFieldsCons({
        reflectSymbol: function () {
            return "panType";
        }
    })(/* #__PURE__ */ Data_Show.showRecordFieldsCons({
        reflectSymbol: function () {
            return "size";
        }
    })(Data_Show.showRecordFieldsNil)(Restaumatic_Menu_Types_Id.showPizzaSize))(Restaumatic_Menu_Types_Id.showPanType))(showPizzaDef))))({
        reflectSymbol: function () {
            return "Pizza";
        }
    }))(/* #__PURE__ */ Data_Show_Generic.genericShowSum(/* #__PURE__ */ Data_Show_Generic.genericShowConstructor(/* #__PURE__ */ Data_Show_Generic.genericShowArgsArgument(/* #__PURE__ */ Data_Show.showRecord()()(/* #__PURE__ */ Data_Show.showRecordFieldsCons({
        reflectSymbol: function () {
            return "id";
        }
    })(/* #__PURE__ */ Data_Show.showRecordFieldsCons({
        reflectSymbol: function () {
            return "sides";
        }
    })(Data_Show.showRecordFieldsNil)(/* #__PURE__ */ Data_Set.showSet(showSideDishKey)))(Restaumatic_Menu_Types_Id.showDishId))))({
        reflectSymbol: function () {
            return "Dish";
        }
    }))(/* #__PURE__ */ Data_Show_Generic.genericShowSum(/* #__PURE__ */ Data_Show_Generic.genericShowConstructor(/* #__PURE__ */ Data_Show_Generic.genericShowArgsArgument(/* #__PURE__ */ Data_Show.showRecord()()(/* #__PURE__ */ Data_Show.showRecordFieldsCons({
        reflectSymbol: function () {
            return "id";
        }
    })(/* #__PURE__ */ Data_Show.showRecordFieldsCons({
        reflectSymbol: function () {
            return "size";
        }
    })(Data_Show.showRecordFieldsNil)(Restaumatic_Menu_Types_Id.showDrinkSize))(Restaumatic_Menu_Types_Id.showDrinkId))))({
        reflectSymbol: function () {
            return "Drink";
        }
    }))(/* #__PURE__ */ Data_Show_Generic.genericShowSum(/* #__PURE__ */ Data_Show_Generic.genericShowConstructor(/* #__PURE__ */ Data_Show_Generic.genericShowArgsArgument(/* #__PURE__ */ Data_Show.showRecord()()(/* #__PURE__ */ Data_Show.showRecordFieldsCons({
        reflectSymbol: function () {
            return "panType";
        }
    })(/* #__PURE__ */ Data_Show.showRecordFieldsCons({
        reflectSymbol: function () {
            return "parts";
        }
    })(/* #__PURE__ */ Data_Show.showRecordFieldsCons({
        reflectSymbol: function () {
            return "size";
        }
    })(Data_Show.showRecordFieldsNil)(Restaumatic_Menu_Types_Id.showPizzaSize))(/* #__PURE__ */ Data_Show.showArray(showPizzaDef)))(Restaumatic_Menu_Types_Id.showPanType))))({
        reflectSymbol: function () {
            return "SplitPizza";
        }
    }))(/* #__PURE__ */ Data_Show_Generic.genericShowSum(/* #__PURE__ */ Data_Show_Generic.genericShowConstructor(/* #__PURE__ */ Data_Show_Generic.genericShowArgsArgument(/* #__PURE__ */ Data_Show.showRecord()()(/* #__PURE__ */ Data_Show.showRecordFieldsCons({
        reflectSymbol: function () {
            return "name";
        }
    })(/* #__PURE__ */ Data_Show.showRecordFieldsCons({
        reflectSymbol: function () {
            return "price";
        }
    })(/* #__PURE__ */ Data_Show.showRecordFieldsCons({
        reflectSymbol: function () {
            return "vatRate";
        }
    })(Data_Show.showRecordFieldsNil)(/* #__PURE__ */ Data_Maybe.showMaybe(Restaumatic_Menu_V2_Types_Taxes.showVatRate)))(Data_Money_Rounded.showMoney))(Data_Show.showString))))({
        reflectSymbol: function () {
            return "CustomProduct";
        }
    }))(/* #__PURE__ */ Data_Show_Generic.genericShowSum(/* #__PURE__ */ Data_Show_Generic.genericShowConstructor(/* #__PURE__ */ Data_Show_Generic.genericShowArgsArgument(Restaumatic_Menu_V2_Types_CartToOrder.showCartProductKey))({
        reflectSymbol: function () {
            return "MenuProduct";
        }
    }))(/* #__PURE__ */ Data_Show_Generic.genericShowConstructor(/* #__PURE__ */ Data_Show_Generic.genericShowArgsArgument(Restaumatic_Menu_V2_Types_CartToOrder.showCartComboKey))({
        reflectSymbol: function () {
            return "MenuCombo";
        }
    }))))))))
};
var eqSideDishKey = {
    eq: /* #__PURE__ */ Data_Eq_Generic.genericEq(genericSideDishKey)(/* #__PURE__ */ Data_Eq_Generic.genericEqConstructor(/* #__PURE__ */ Data_Eq_Generic.genericEqArgument(/* #__PURE__ */ Data_Eq.eqRec()(/* #__PURE__ */ Data_Eq.eqRowCons(/* #__PURE__ */ Data_Eq.eqRowCons(Data_Eq.eqRowNil)()({
        reflectSymbol: function () {
            return "sideId";
        }
    })(Restaumatic_Menu_Types_Id.eqSideId))()({
        reflectSymbol: function () {
            return "dishId";
        }
    })(Restaumatic_Menu_Types_Id.eqDishId)))))
};
var ordSideDishKey = {
    compare: /* #__PURE__ */ Data_Ord_Generic.genericCompare(genericSideDishKey)(/* #__PURE__ */ Data_Ord_Generic.genericOrdConstructor(/* #__PURE__ */ Data_Ord_Generic.genericOrdArgument(/* #__PURE__ */ Data_Ord.ordRecord()(/* #__PURE__ */ Data_Ord.ordRecordCons(/* #__PURE__ */ Data_Ord.ordRecordCons(Data_Ord.ordRecordNil)()({
        reflectSymbol: function () {
            return "sideId";
        }
    })(Restaumatic_Menu_Types_Id.ordSideId))()({
        reflectSymbol: function () {
            return "dishId";
        }
    })(Restaumatic_Menu_Types_Id.ordDishId))))),
    Eq0: function () {
        return eqSideDishKey;
    }
};
var eqPizzaDef = {
    eq: /* #__PURE__ */ Data_Eq_Generic.genericEq(genericPizzaDef)(/* #__PURE__ */ Data_Eq_Generic.genericEqSum(/* #__PURE__ */ Data_Eq_Generic.genericEqConstructor(/* #__PURE__ */ Data_Eq_Generic.genericEqArgument(Restaumatic_Menu_Types_Id.eqPizzaId)))(/* #__PURE__ */ Data_Eq_Generic.genericEqConstructor(/* #__PURE__ */ Data_Eq_Generic.genericEqArgument(/* #__PURE__ */ Data_Eq.eqRec()(/* #__PURE__ */ Data_Eq.eqRowCons(/* #__PURE__ */ Data_Eq.eqRowCons(Data_Eq.eqRowNil)()({
        reflectSymbol: function () {
            return "toppings";
        }
    })(/* #__PURE__ */ Data_MultiSet.eqMultiSet(Restaumatic_Menu_Types_Id.eqToppingId)))()({
        reflectSymbol: function () {
            return "basePizzaId";
        }
    })(Restaumatic_Menu_Types_Id.eqPizzaId))))))
};
var eqProductKey = {
    eq: /* #__PURE__ */ Data_Eq_Generic.genericEq(genericProductKey)(/* #__PURE__ */ Data_Eq_Generic.genericEqSum(/* #__PURE__ */ Data_Eq_Generic.genericEqConstructor(/* #__PURE__ */ Data_Eq_Generic.genericEqArgument(/* #__PURE__ */ Data_Eq.eqRec()(/* #__PURE__ */ Data_Eq.eqRowCons(/* #__PURE__ */ Data_Eq.eqRowCons(/* #__PURE__ */ Data_Eq.eqRowCons(Data_Eq.eqRowNil)()({
        reflectSymbol: function () {
            return "size";
        }
    })(Restaumatic_Menu_Types_Id.eqPizzaSize))()({
        reflectSymbol: function () {
            return "panType";
        }
    })(Restaumatic_Menu_Types_Id.eqPanType))()({
        reflectSymbol: function () {
            return "def";
        }
    })(eqPizzaDef)))))(/* #__PURE__ */ Data_Eq_Generic.genericEqSum(/* #__PURE__ */ Data_Eq_Generic.genericEqConstructor(/* #__PURE__ */ Data_Eq_Generic.genericEqArgument(/* #__PURE__ */ Data_Eq.eqRec()(/* #__PURE__ */ Data_Eq.eqRowCons(/* #__PURE__ */ Data_Eq.eqRowCons(Data_Eq.eqRowNil)()({
        reflectSymbol: function () {
            return "sides";
        }
    })(/* #__PURE__ */ Data_Set.eqSet(eqSideDishKey)))()({
        reflectSymbol: function () {
            return "id";
        }
    })(Restaumatic_Menu_Types_Id.eqDishId)))))(/* #__PURE__ */ Data_Eq_Generic.genericEqSum(/* #__PURE__ */ Data_Eq_Generic.genericEqConstructor(/* #__PURE__ */ Data_Eq_Generic.genericEqArgument(/* #__PURE__ */ Data_Eq.eqRec()(/* #__PURE__ */ Data_Eq.eqRowCons(/* #__PURE__ */ Data_Eq.eqRowCons(Data_Eq.eqRowNil)()({
        reflectSymbol: function () {
            return "size";
        }
    })(Restaumatic_Menu_Types_Id.eqDrinkSize))()({
        reflectSymbol: function () {
            return "id";
        }
    })(Restaumatic_Menu_Types_Id.eqDrinkId)))))(/* #__PURE__ */ Data_Eq_Generic.genericEqSum(/* #__PURE__ */ Data_Eq_Generic.genericEqConstructor(/* #__PURE__ */ Data_Eq_Generic.genericEqArgument(/* #__PURE__ */ Data_Eq.eqRec()(/* #__PURE__ */ Data_Eq.eqRowCons(/* #__PURE__ */ Data_Eq.eqRowCons(/* #__PURE__ */ Data_Eq.eqRowCons(Data_Eq.eqRowNil)()({
        reflectSymbol: function () {
            return "size";
        }
    })(Restaumatic_Menu_Types_Id.eqPizzaSize))()({
        reflectSymbol: function () {
            return "parts";
        }
    })(/* #__PURE__ */ Data_Eq.eqArray(eqPizzaDef)))()({
        reflectSymbol: function () {
            return "panType";
        }
    })(Restaumatic_Menu_Types_Id.eqPanType)))))(/* #__PURE__ */ Data_Eq_Generic.genericEqSum(/* #__PURE__ */ Data_Eq_Generic.genericEqConstructor(/* #__PURE__ */ Data_Eq_Generic.genericEqArgument(/* #__PURE__ */ Data_Eq.eqRec()(/* #__PURE__ */ Data_Eq.eqRowCons(/* #__PURE__ */ Data_Eq.eqRowCons(/* #__PURE__ */ Data_Eq.eqRowCons(Data_Eq.eqRowNil)()({
        reflectSymbol: function () {
            return "vatRate";
        }
    })(/* #__PURE__ */ Data_Maybe.eqMaybe(Restaumatic_Menu_V2_Types_Taxes.eqVatRate)))()({
        reflectSymbol: function () {
            return "price";
        }
    })(Data_Money_Rounded.eqMoney))()({
        reflectSymbol: function () {
            return "name";
        }
    })(Data_Eq.eqString)))))(/* #__PURE__ */ Data_Eq_Generic.genericEqSum(/* #__PURE__ */ Data_Eq_Generic.genericEqConstructor(/* #__PURE__ */ Data_Eq_Generic.genericEqArgument(Restaumatic_Menu_V2_Types_CartToOrder.eqCartProductKey)))(/* #__PURE__ */ Data_Eq_Generic.genericEqConstructor(/* #__PURE__ */ Data_Eq_Generic.genericEqArgument(Restaumatic_Menu_V2_Types_CartToOrder.eqCartComboKey)))))))))
};
var ordPizzaDef = {
    compare: /* #__PURE__ */ Data_Ord_Generic.genericCompare(genericPizzaDef)(/* #__PURE__ */ Data_Ord_Generic.genericOrdSum(/* #__PURE__ */ Data_Ord_Generic.genericOrdConstructor(/* #__PURE__ */ Data_Ord_Generic.genericOrdArgument(Restaumatic_Menu_Types_Id.ordPizzaId)))(/* #__PURE__ */ Data_Ord_Generic.genericOrdConstructor(/* #__PURE__ */ Data_Ord_Generic.genericOrdArgument(/* #__PURE__ */ Data_Ord.ordRecord()(/* #__PURE__ */ Data_Ord.ordRecordCons(/* #__PURE__ */ Data_Ord.ordRecordCons(Data_Ord.ordRecordNil)()({
        reflectSymbol: function () {
            return "toppings";
        }
    })(/* #__PURE__ */ Data_MultiSet.ordMultiSet(Restaumatic_Menu_Types_Id.ordToppingId)))()({
        reflectSymbol: function () {
            return "basePizzaId";
        }
    })(Restaumatic_Menu_Types_Id.ordPizzaId)))))),
    Eq0: function () {
        return eqPizzaDef;
    }
};
var ordProductKey = {
    compare: /* #__PURE__ */ Data_Ord_Generic.genericCompare(genericProductKey)(/* #__PURE__ */ Data_Ord_Generic.genericOrdSum(/* #__PURE__ */ Data_Ord_Generic.genericOrdConstructor(/* #__PURE__ */ Data_Ord_Generic.genericOrdArgument(/* #__PURE__ */ Data_Ord.ordRecord()(/* #__PURE__ */ Data_Ord.ordRecordCons(/* #__PURE__ */ Data_Ord.ordRecordCons(/* #__PURE__ */ Data_Ord.ordRecordCons(Data_Ord.ordRecordNil)()({
        reflectSymbol: function () {
            return "size";
        }
    })(Restaumatic_Menu_Types_Id.ordPizzaSize))()({
        reflectSymbol: function () {
            return "panType";
        }
    })(Restaumatic_Menu_Types_Id.ordPanType))()({
        reflectSymbol: function () {
            return "def";
        }
    })(ordPizzaDef)))))(/* #__PURE__ */ Data_Ord_Generic.genericOrdSum(/* #__PURE__ */ Data_Ord_Generic.genericOrdConstructor(/* #__PURE__ */ Data_Ord_Generic.genericOrdArgument(/* #__PURE__ */ Data_Ord.ordRecord()(/* #__PURE__ */ Data_Ord.ordRecordCons(/* #__PURE__ */ Data_Ord.ordRecordCons(Data_Ord.ordRecordNil)()({
        reflectSymbol: function () {
            return "sides";
        }
    })(/* #__PURE__ */ Data_Set.ordSet(ordSideDishKey)))()({
        reflectSymbol: function () {
            return "id";
        }
    })(Restaumatic_Menu_Types_Id.ordDishId)))))(/* #__PURE__ */ Data_Ord_Generic.genericOrdSum(/* #__PURE__ */ Data_Ord_Generic.genericOrdConstructor(/* #__PURE__ */ Data_Ord_Generic.genericOrdArgument(/* #__PURE__ */ Data_Ord.ordRecord()(/* #__PURE__ */ Data_Ord.ordRecordCons(/* #__PURE__ */ Data_Ord.ordRecordCons(Data_Ord.ordRecordNil)()({
        reflectSymbol: function () {
            return "size";
        }
    })(Restaumatic_Menu_Types_Id.ordDrinkSize))()({
        reflectSymbol: function () {
            return "id";
        }
    })(Restaumatic_Menu_Types_Id.ordDrinkId)))))(/* #__PURE__ */ Data_Ord_Generic.genericOrdSum(/* #__PURE__ */ Data_Ord_Generic.genericOrdConstructor(/* #__PURE__ */ Data_Ord_Generic.genericOrdArgument(/* #__PURE__ */ Data_Ord.ordRecord()(/* #__PURE__ */ Data_Ord.ordRecordCons(/* #__PURE__ */ Data_Ord.ordRecordCons(/* #__PURE__ */ Data_Ord.ordRecordCons(Data_Ord.ordRecordNil)()({
        reflectSymbol: function () {
            return "size";
        }
    })(Restaumatic_Menu_Types_Id.ordPizzaSize))()({
        reflectSymbol: function () {
            return "parts";
        }
    })(/* #__PURE__ */ Data_Ord.ordArray(ordPizzaDef)))()({
        reflectSymbol: function () {
            return "panType";
        }
    })(Restaumatic_Menu_Types_Id.ordPanType)))))(/* #__PURE__ */ Data_Ord_Generic.genericOrdSum(/* #__PURE__ */ Data_Ord_Generic.genericOrdConstructor(/* #__PURE__ */ Data_Ord_Generic.genericOrdArgument(/* #__PURE__ */ Data_Ord.ordRecord()(/* #__PURE__ */ Data_Ord.ordRecordCons(/* #__PURE__ */ Data_Ord.ordRecordCons(/* #__PURE__ */ Data_Ord.ordRecordCons(Data_Ord.ordRecordNil)()({
        reflectSymbol: function () {
            return "vatRate";
        }
    })(/* #__PURE__ */ Data_Maybe.ordMaybe(Restaumatic_Menu_V2_Types_Taxes.ordVatRate)))()({
        reflectSymbol: function () {
            return "price";
        }
    })(Data_Money_Rounded.ordMoney))()({
        reflectSymbol: function () {
            return "name";
        }
    })(Data_Ord.ordString)))))(/* #__PURE__ */ Data_Ord_Generic.genericOrdSum(/* #__PURE__ */ Data_Ord_Generic.genericOrdConstructor(/* #__PURE__ */ Data_Ord_Generic.genericOrdArgument(Restaumatic_Menu_V2_Types_CartToOrder.ordCartProductKey)))(/* #__PURE__ */ Data_Ord_Generic.genericOrdConstructor(/* #__PURE__ */ Data_Ord_Generic.genericOrdArgument(Restaumatic_Menu_V2_Types_CartToOrder.ordCartComboKey))))))))),
    Eq0: function () {
        return eqProductKey;
    }
};
var encodeForeignSideDishKey = /* #__PURE__ */ Foreign_Generic_Class.recordEncode()(/* #__PURE__ */ Foreign_Generic_Class.encodeRecordCons()(/* #__PURE__ */ Foreign_Generic_Class.encodeRecordCons()(Foreign_Generic_Class.encodeRecordNil)({
    reflectSymbol: function () {
        return "sideId";
    }
})(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(Restaumatic_Menu_Types_Id.encodeForeignSideId)))({
    reflectSymbol: function () {
        return "dishId";
    }
})(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(Restaumatic_Menu_Types_Id.encodeDishId)));
var decodeForeignSideDishKey = /* #__PURE__ */ Foreign_Generic_Class.recordDecode()(/* #__PURE__ */ Foreign_Generic_Class.decodeRecordCons()(/* #__PURE__ */ Foreign_Generic_Class.decodeRecordCons()(Foreign_Generic_Class.decodeRecordNil)({
    reflectSymbol: function () {
        return "sideId";
    }
})(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsOther(Restaumatic_Menu_Types_Id.decodeForeignSideId))())({
    reflectSymbol: function () {
        return "dishId";
    }
})(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsOther(Restaumatic_Menu_Types_Id.decodeDishId))());
var asSplitPizzaKey = function (v) {
    if (v instanceof Pizza) {
        return new Data_Maybe.Just(toSplitPizzaKey(v.value0));
    };
    if (v instanceof SplitPizza) {
        return new Data_Maybe.Just(v.value0);
    };
    return Data_Maybe.Nothing.value;
};
export {
    StandardPizza,
    CustomPizza,
    Pizza,
    Dish,
    Drink,
    SplitPizza,
    CustomProduct,
    MenuProduct,
    MenuCombo,
    SideDishKey,
    asSplitPizzaKey,
    isCustomPizza,
    isSplitPizza,
    pizzaId,
    productKeyDishId,
    toSplitPizzaKey,
    genericProductKey,
    eqProductKey,
    ordProductKey,
    showProductKey,
    genericPizzaDef,
    eqPizzaDef,
    ordPizzaDef,
    showPizzaDef,
    genericSideDishKey,
    eqSideDishKey,
    ordSideDishKey,
    showSideDishKey,
    decodeForeignSideDishKey,
    udecodeForeignSideDishKey,
    encodeForeignSideDishKey
};
//# sourceMappingURL=index.js.map
